import React, {useContext, useEffect} from 'react'
import logo from '../../assets/images/freshcart-logo.svg'
import { Link, NavLink } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { cartContext } from './../../Context/CartContext';
import $ from 'jquery'
import { Divider } from '@mui/material';



export default function Navbar({userData, signOut, userDataName}) {

  let {cartData, wishListCount, shakeCart, shakeWish} =  useContext(cartContext)

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));


  useEffect(() => {
    shakeCart? $('.cartCount').addClass('fa-shake') : $('.cartCount').removeClass('fa-shake')
    shakeWish? $('.wishCount').addClass('fa-shake') : $('.wishCount').removeClass('fa-shake')
  }, [shakeCart, shakeWish])

  


  
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="Logo" />
          </Link>

          <button
            className="navbar-toggler d-lg-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavId"
            aria-controls="collapsibleNavId"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="collapsibleNavId">
            <ul className="navbar-nav me-auto mt-2 mt-lg-0">

              {/* Home Link */}
              <li className="nav-item">
                <NavLink 
                  className={`nav-link hovering`} to="/">
                  Home
                </NavLink>
              </li>
              {/* All Products Link */}
              <li className="nav-item">
                <NavLink
                  className={`nav-link hovering`}
                  to="products"
                >
                  Products
                </NavLink>
              </li>
              {/* Categories Link */}
              <li className="nav-item">
                <NavLink
                  className={`nav-link hovering`}
                  to="categories"
                >
                  Categories
                </NavLink>
              </li>
              {/* Brands Link */}
              <li className="nav-item">
                <NavLink
                  className={`nav-link hovering`}
                  to="brands"
                >
                  Brands
                </NavLink>
              </li>
            </ul>

            {/* Social Icons */}
            <ul className="navbar-nav ms-auto mt-2 mt-lg-0">
              {/* Facebook */}
              <li className="nav-item">
                <Link className="nav-link px-0">
                  <i className="fab fa-facebook mx-2 hovering"></i>
                </Link>
              </li>
              {/* Instagram */}
              <li className="nav-item">
                <Link className="nav-link px-0">
                  <i className="fab fa-instagram mx-2 hovering"></i>
                </Link>
              </li>
              {/* TikTok */}
              <li className="nav-item">
                <Link className="nav-link px-0">
                  <i className="fab fa-tiktok mx-2 hovering"></i>
                </Link>
              </li>
              {/* Twitter */}
              <li className="nav-item">
                <Link className="nav-link px-0">
                  <i className="fab fa-twitter mx-2 hovering"></i>
                </Link>
              </li>
              {/* Youtube */}
              <li className="nav-item">
                <Link className="nav-link px-0">
                  <i className="fab fa-youtube mx-2 hovering"></i>
                </Link>
              </li>

              {/*  Check if user has account to display the first letter of his name and display dropdown menu that contains Profile Icon and  Orders Icon */}
              {userData !== null ? (
                <li className="nav-item dropdown">
                  <span
                    className="nav-link dropdown-toggle pe-2 py-1"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Stack direction="row" spacing={1}>
                      <Avatar
                        className="p-3 Btn me-1"
                        sx={{
                          width: 26,
                          height: 26,
                          color: "#0aad0a",
                          backgroundColor: "white",
                          borderBlockEndColor: "green",
                        }}
                      >
                        {userDataName?.charAt(0).toUpperCase()}
                      </Avatar>
                    </Stack>
                  </span>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item hovering" to="profile">
                        My account{" "}
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item hovering" to="allorders">
                        <i className="fa-solid fa-box me-2"></i> Orders{" "}
                      </Link>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <span
                        className="dropdown-item cursor-pointer hovering"
                        onClick={signOut}
                      >
                        Sign Out
                      </span>
                    </li>
                  </ul>
                </li>
              ) : (

                // if user has no account then display in the dropmenu login or register options
                <li className="nav-item dropdown">
                  <span
                    className="nav-link dropdown-toggle px-2"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="text-main fs-5 fa-regular fa-user"></i>
                  </span>

                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item hovering" to="login">
                        Sign in
                      </Link>
                    </li>

                    <li>
                      <Link className="dropdown-item hovering" to="register">
                        Join for free
                      </Link>
                    </li>
                  </ul>

                </li>
              )}
{/* lejockey-fresh-cart */}
              <Divider
                className="bg-main"
                orientation="vertical"
                flexItem
              />

              {/* Check if user has account to display Cart Icon with Cart count */}
              {userData ? (
                <li className="nav-item">
                  <Link className={`nav-link py-0 ps-0 cartCount mx-0 mx-lg-1 ${cartData?.numOfCartItems < 1 && 'pe-0'}`} to="cart">
                    <IconButton aria-label="cart" className="p-0 mt-1">
                      <StyledBadge
                        badgeContent={
                          cartData?.numOfCartItems === null
                            ? 0
                            : cartData?.numOfCartItems
                        }
                        color="warning"
                        className="Btn rounded-circle p-1"
                      >
                        <ShoppingCartIcon />
                      </StyledBadge>
                    </IconButton>
                  </Link>
                </li>
              ) : (
                // if user has no account and press on Cart Icon navigate to login
                <li className="nav-item">
                  <Link className="nav-link ms-lg-0 ms-1" to="login">
                    <i className="fs-5 text-main fa-solid fa-cart-shopping"></i>
                  </Link>
                </li>
              )}

              <Divider
                className="bg-main"
                orientation="vertical"
                flexItem
              />
              
              {/* Check if user has account to display WishList Icon with WishList count */}
              {userData ? (
                <li className="nav-item ">
                  <Link className="nav-link py-0 ps-0 wishCount" to="wishlist">
                    <IconButton aria-label="cart" className="p-0 mt-1">
                      <StyledBadge
                        badgeContent={wishListCount}
                        color="warning"
                        className="Btn rounded-circle p-1 ms-0 ms-lg-1"
                      >
                        <FavoriteBorderIcon />
                      </StyledBadge>
                    </IconButton>
                  </Link>
                </li>
              ) : (
                // if user has no account and press on WishList Icon navigate to login
                <li className="nav-item">
                  <Link className="nav-link ms-lg-0 ms-2" to="login">
                    <i className="fs-5 text-main fa-regular fa-heart"></i>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
  
}
